export default __webpack_public_path__ + "static/media/media8.a98c7a48.jpeg";